import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-10.808566, 165.816543, 4.2],
  [-10.808468, 165.816607, 4],
  [-10.808384, 165.816704, 4],
  [-10.808317, 165.81679, 4],
  [-10.808279, 165.816919, 4.2],
  [-10.808279, 165.817037, 4.6],
  [-10.808309, 165.817144, 5.2],
  [-10.808356, 165.817251, 5.6],
  [-10.80841, 165.817337, 6.2],
  [-10.808463, 165.817434, 6.6],
  [-10.808513, 165.817519, 7.2],
  [-10.808545, 165.817627, 7.6],
  [-10.808529, 165.817734, 8.2],
  [-10.808452, 165.817788, 8.6],
  [-10.808364, 165.817755, 9.2],
  [-10.80829, 165.817691, 9.6],
  [-10.808217, 165.817627, 10],
  [-10.808143, 165.817573, 10.4],
  [-10.808061, 165.817519, 10.8],
  [-10.807971, 165.817509, 11],
  [-10.807879, 165.817519, 11.2],
  [-10.807795, 165.817573, 11.4],
  [-10.807713, 165.817616, 11.6],
  [-10.807637, 165.81768, 11.8],
  [-10.807565, 165.817734, 12.2],
  [-10.807497, 165.817798, 12.4],
  [-10.807431, 165.817873, 12.8],
  [-10.80737, 165.817949, 13.2],
  [-10.80731, 165.818024, 13.4],
  [-10.807256, 165.818099, 13.8],
  [-10.807206, 165.818185, 14],
  [-10.807158, 165.81826, 14.2],
  [-10.807115, 165.818346, 14.4],
  [-10.807077, 165.818442, 14.4],
  [-10.807049, 165.818528, 14.4],
  [-10.807043, 165.818624, 14.4],
  [-10.807057, 165.81871, 14.6],
  [-10.807082, 165.818807, 14.6],
  [-10.807113, 165.818893, 14.6],
  [-10.807144, 165.818989, 14.6],
  [-10.807172, 165.819097, 14.8],
  [-10.807188, 165.819182, 14.8],
  [-10.807183, 165.819279, 15],
  [-10.807147, 165.819376, 15.2],
  [-10.807082, 165.819429, 15.2],
  [-10.806998, 165.819472, 15.2],
  [-10.806908, 165.819504, 15.2],
  [-10.806813, 165.819504, 15],
  [-10.806717, 165.819494, 15],
  [-10.806634, 165.819429, 14.8],
  [-10.806571, 165.819354, 14.6],
  [-10.80652, 165.819268, 14.4],
  [-10.806476, 165.819172, 14.2],
  [-10.80644, 165.819086, 13.8],
  [-10.806409, 165.818979, 13.6],
  [-10.806381, 165.818871, 13.2],
  [-10.806356, 165.818764, 12.8],
  [-10.80633, 165.818657, 12.4],
  [-10.806302, 165.818528, 12],
  [-10.806267, 165.818421, 11.6],
  [-10.806218, 165.818303, 11],
  [-10.806148, 165.818206, 10.4],
  [-10.806036, 165.818152, 10.2],
  [-10.805915, 165.818163, 10],
  [-10.80583, 165.81826, 10],
  [-10.805797, 165.818378, 9.6],
  [-10.805798, 165.818517, 9.4],
  [-10.805818, 165.818657, 9],
  [-10.805851, 165.818775, 8.6],
  [-10.805895, 165.818914, 8.2],
  [-10.805941, 165.819032, 7.8],
  [-10.805988, 165.819161, 7.4],
  [-10.806044, 165.81929, 6.8],
  [-10.806107, 165.819418, 6.2],
  [-10.806173, 165.819536, 5.8],
  [-10.806235, 165.819665, 5.4],
  [-10.806284, 165.819794, 5.2],
  [-10.806323, 165.819933, 5.2],
  [-10.806361, 165.820073, 5.2],
  [-10.806402, 165.820191, 5.2],
];

export default stream;
